import { intersection, size } from "lodash";
import { isInternalSupportUser } from "src/services/auth";

const canPerform = (user, userRoles, allowedRoles) => {
  if (user && isInternalSupportUser(user)) {
    return true;
  }
  return size(intersection(userRoles, allowedRoles)) > 0;
};

export default canPerform;
